import { useCallback, useEffect, useState } from "react";
import { API } from "../../../services/api";
import { mergeCommandeFlags } from "../model/commandeListRules";

// Indicateurs lu / favori de la liste : mise à jour optimiste, annulée si le serveur refuse.
export function useCommandeListFlags(commandes, onFlagChange) {
    const [flags, setFlags] = useState({});

    useEffect(() => {
        setFlags(prev => mergeCommandeFlags(prev, commandes));
    }, [commandes]);

    const getFlag = useCallback((cmd, key) => {
        return flags[cmd.id]?.[key] ?? cmd[key] ?? false;
    }, [flags]);

    const patchFlags = useCallback(async (id, changes, previousChanges = {}) => {
        setFlags(prev => ({ ...prev, [id]: { ...prev[id], ...changes } }));
        onFlagChange?.(id, changes);
        try {
            if (changes.favorite !== undefined) {
                await API.patch(`/commandes/${id}/favorite`, { favorite: changes.favorite });
            }
            if (changes.read !== undefined) {
                await API.patch(`/commandes/${id}/read`, { read: changes.read });
            }
        } catch {
            setFlags(prev => { const n = { ...prev }; delete n[id]; return n; });
            onFlagChange?.(id, previousChanges);
        }
    }, [onFlagChange]);

    return { getFlag, patchFlags };
}
